// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__332dl","label":"CategoryService_label__oXPF-","location":"CategoryService_location__3-9wH"};